<template>
  <Plate :agent="agent" :lead="lead" :beneficiary="beneficiary">
    <component
      :agent="agent"
      :lead="lead"
      :is="platesByStep[step]"
      :beneficiary="beneficiary"
    />
  </Plate>
</template>

<script>
import { mapGetters } from 'vuex';
import { PlatesSteps } from '@/common/variables';
import Plate from '@/components/lead/plates/Plate';
import IntroPlate from '@/components/lead/plates/parts/IntroPlate';
import OccupationPlate from '@/components/lead/plates/parts/OccupationPlate';
import AnalysisPlate from '@/components/lead/plates/parts/AnalysisPlate';
import DisabledAnalysisPlate from '@/components/lead/plates/parts/DisabledAnalysisPlate';
import DisabledNeedsPlate from '@/components/lead/plates/parts/DisabledNeedsPlate';
import ProcessPlate from '@/components/lead/plates/parts/ProcessPlate';
import NeedsPlate from '@/components/lead/plates/parts/NeedsPlate';
import BasicInfoPlate from '@/components/lead/plates/parts/BasicInfoPlate';
import HealthPlate from '@/components/lead/plates/parts/HealthPlate';
import DisabledHealthFirstPlate from '@/components/lead/plates/parts/DisabledHealthFirstPlate';
import DisabledHealthSecondPlate from '@/components/lead/plates/parts/DisabledHealthSecondPlate';
import GeneralHealthPlate from '@/components/lead/plates/parts/GeneralHealthPlate';
import CompanyPlate from '@/components/lead/plates/parts/CompanyPlate';
import ProductPlate from '@/components/lead/plates/parts/ProductPlate';
import ResultPlate from '@/components/lead/plates/parts/ResultPlate';
import EmailPlate from '@/components/lead/plates/parts/EmailPlate';
import BeneficiaryPlate from '@/components/lead/plates/parts/BeneficiaryPlate';
import PaymentPlate from '@/components/lead/plates/parts/PaymentPlate';
import SummaryPlate from '@/components/lead/plates/parts/SummaryPlate';

export default {
  name: 'PlatesFactory',
  components: { Plate },
  data: () => ({
    platesByStep: {
      [PlatesSteps.intro]: IntroPlate,
      [PlatesSteps.occupation]: OccupationPlate,
      [PlatesSteps.disabledAnalysis]: DisabledAnalysisPlate,
      [PlatesSteps.disabledNeeds]: DisabledNeedsPlate,
      [PlatesSteps.analysis]: AnalysisPlate,
      [PlatesSteps.needs]: NeedsPlate,
      [PlatesSteps.process]: ProcessPlate,

      [PlatesSteps.basicInfo]: BasicInfoPlate,
      [PlatesSteps.health]: HealthPlate,
      [PlatesSteps.disabledHealthFirst]: DisabledHealthFirstPlate,
      [PlatesSteps.disabledHealthSecond]: DisabledHealthSecondPlate,
      [PlatesSteps.generalHealth]: GeneralHealthPlate,
      [PlatesSteps.company]: CompanyPlate,
      [PlatesSteps.product]: ProductPlate,
      [PlatesSteps.result]: ResultPlate,

      [PlatesSteps.email]: EmailPlate,
      [PlatesSteps.beneficiary]: BeneficiaryPlate,
      [PlatesSteps.payment]: PaymentPlate,
      [PlatesSteps.summary]: SummaryPlate,
    },
  }),
  computed: {
    ...mapGetters({ beneficiary: 'plates/beneficiary' }),
  },
  props: {
    step: {
      type: String,
    },
    agent: {
      type: Object,
    },
    lead: {
      type: Object,
    },
  },
  mounted() {
    this.sockets.subscribe('UPDATE_LEAD', (payload) => {
      console.log({ payload });
    });
  },
};
</script>
